import React from 'react';
import { Article, Modal } from '../../components';
import { sealy, zombie, ticketDesk, petbabies, click360, dwight } from './imports';
import './projects.css';

const Projects = () => {
  return (
    <div className="hs__projects section__padding" id="projects">
      <div className="hs__projects-heading">
        <h2 className="gradient__text">Explore My Latest and Greatest Projects Below!</h2>
      </div>
      <div className="hs__projects-container_groupA">
        <div className="hs__projects-container_groupB">
          <div className="hs__projects-container_groupA">
            <div className="hs__projects-container_project">
              <Article
                imgUrl={click360}
                title="Click360"
                tools="Lifestyle Ecommerce Platform"
                description="Click360 is a premium e-commerce destination offering a seamless online shopping experience across leading global brands including Samsung, LEGO, Callaway, and official Formula 1 merchandise. Designed for performance, convenience, and modern retail, the platform delivers a trusted digital shopping experience tailored for customers who value quality, innovation, and world-class brands."
              />
              <div className="hs__projects-container_article-content">
                <a href="https://click360.co.za/" target="_blank" rel="noreferrer"><p>Visit Online Store</p></a>
              </div>
            </div>
          </div>
          <div className="hs__projects-container_groupA">
            <div className="hs__projects-container_project">
              <Article
                imgUrl={petbabies}
                title="PetBabies"
                tools="Pet Care Ecommerce Platform"
                description="PetBabies is a modern online pet store delivering trusted pet care products to animal lovers across South Africa. Featuring leading brands such as Hills, Acana, Rogz, and Montego, the platform caters to every kind of pet parent. From dog and cat owners to fish, rabbit, and small animal enthusiasts, through a seamless shopping experience built around quality, convenience, and care."
              />
              <div className="hs__projects-container_article-content">
                <a href="https://petbabies.co.za/" target="_blank" rel="noreferrer"><p>Visit Online Store</p></a>
              </div>
            </div>
          </div>
          <div className="hs__projects-container_groupA">
            <div className="hs__projects-container_project">
              <Article
                imgUrl={dwight}
                title="Dwight AI Agent"
                tools="NextJs | Tailwind"
                description="A custom AI Agent, trained to understand your business like an experienced team member. From workflows to client needs, Dwight provides seamless, intelligent support—right where you need it most."
              />
              <div className="hs__projects-container_article-content">
                <a href="https://justaskdwight.com/" target="_blank" rel="noreferrer"><p>View Application</p></a>
              </div>
            </div>
          </div>
          <div className="hs__projects-container_groupA">
            <div className="hs__projects-container_project">
              <Article
                imgUrl={sealy}
                title="The Mattress People"
                tools="Sleep & Bedding Retail Platform"
                description="The Mattress People is a trusted sleep and bedding retailer offering premium comfort solutions from leading brands including Sealy, Cloud Nine, and Restonic. From advanced pocket spring systems and motion beds to luxury foam mattresses, the platform delivers a seamless shopping experience designed to help customers find the perfect balance of comfort, support, and quality sleep."
              />
              <div className="hs__projects-container_article-content">
                <a href="https://www.themattresspeople.co.za/" target="_blank" rel="noreferrer"><p>Visit Online Store</p></a>
              </div>
            </div>
          </div>
          <div className="hs__projects-container_groupA">
            <div className="hs__projects-container_project">
              <Article
                imgUrl={ticketDesk}
                title="Ticket Desk"
                tools="PostgreSQL | Retool"
                description="Full-stack web app to seamlessly manage tickets and improve response time with SMS and email alerts, just like the pros at Pager Duty!"
              />
              <div className="hs__projects-container_article-content">
                <a href="https://github.com/devSoni108/page-up" target="_blank" rel="noreferrer"><p>View Code</p></a>
                <Modal />
              </div>
            </div>
          </div>
          <div className="hs__projects-container_groupA">
            <div className="hs__projects-container_project">
              <Article
                imgUrl={zombie}
                title="Run Doggo"
                tools="JavaScript | CSS"
                description="Join Russel, the intrepid canine from Canada, as he tries to escape the creatures of the night and make it back home in this 2D JavaScript game."
              />
              <div className="hs__projects-container_article-content">
                <a href="https://github.com/devSoni108/run-doggo" target="_blank" rel="noreferrer"><p>View Code</p></a>
                <a href="https://run-doggo.netlify.app/" target="_blank" rel="noreferrer"><p>Play Game Using Keyboard</p></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
